import React from 'react';
import RockPaperScissors from './RockPaperScissors'; // Import the RockPaperScissors component

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <RockPaperScissors /> {/* Render the RockPaperScissors component*/}
      </header>
    </div>
  );
}

export default App;